import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import {
  COMPTABLE_EXPERTISE_ID,
  MEDICAL_EXPERTISE_ID,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { translate } from 'containers/services/translate';
import {
  EXPERTISES,
  EXPERTISES_FIELDS,
  EXPERTISE_TYPE,
} from 'containers/data-structure';
import { VictimType } from 'typings/globalTypes';
import { TextField, InputAdornment } from '@material-ui/core';
import { get } from 'lodash';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

export interface VictimExpertiseProps {
  intl: IntlShape;
  dahirAmounts: { [key: string]: number };
  isAppeal?: boolean;
  expertiseType: any;
  handleVictimChange: Function;
  victim: VictimType;
  expertises: any;
  isInputChanged: any;
  index: any;
  setExpertiseFieldValue: any;
  withAccountingExpertise?: any;
  isDisabled: boolean;
}

const VictimExpertise: React.FC<VictimExpertiseProps> = ({
  isAppeal,
  expertiseType,
  ...props
}): JSX.Element => {
  return (
    <main>
      {expertiseType === EXPERTISES.MEDICAL_EXPERTISE ? (
        <>
          <TextField
            name="compensationAmount"
            id="compensationAmount"
            label={translate(messages.compensationFieldTitle, props)}
            value={props.setExpertiseFieldValue(
              String(props.victim.id),
              'compensationAmount',
            )}
            className="calculated-amount"
            type="number"
            onChange={props.handleVictimChange(
              props.victim?.id,
              MEDICAL_EXPERTISE_ID,
              props.victim?.victimKey,
            )}
            error={
              (props.expertises[EXPERTISES.MEDICAL_EXPERTISE][props.index] ===
                undefined ||
                !props.expertises[EXPERTISES.MEDICAL_EXPERTISE][props.index]
                  ?.compensationAmount) &&
              props.expertises[EXPERTISES.MEDICAL_EXPERTISE][props.index]
                ?.compensationAmount !== 0 &&
              !props.isInputChanged
            }
            helperText={
              (props.expertises[EXPERTISES.MEDICAL_EXPERTISE][props.index] ===
                undefined ||
                !props.expertises[EXPERTISES.MEDICAL_EXPERTISE][props.index]
                  ?.compensationAmount) &&
              props.expertises[EXPERTISES.MEDICAL_EXPERTISE][props.index]
                ?.compensationAmount !== 0 &&
              !props.isInputChanged
                ? translate(messages.validateRequiredField, props)
                : ''
            }
            disabled={props.isDisabled}
          />
          {featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
            get(props.withAccountingExpertise, 'hasAccountingExpertise') && (
              <TextField
                name="evaluationAmount"
                label={translate(messages.revenueFieldTitle, props)}
                value={props.setExpertiseFieldValue(
                  String(props.victim.id),
                  'evaluationAmount',
                )}
                className="calculated-amount"
                onChange={props.handleVictimChange(
                  props.victim?.id,
                  MEDICAL_EXPERTISE_ID,
                  props.victim?.victimKey,
                )}
                type="number"
                error={
                  (props.expertises[EXPERTISES.MEDICAL_EXPERTISE][
                    props.index
                  ] === undefined ||
                    !props.expertises[EXPERTISES.MEDICAL_EXPERTISE][props.index]
                      ?.evaluationAmount) &&
                  props.expertises[EXPERTISES.MEDICAL_EXPERTISE][props.index]
                    ?.evaluationAmount !== 0 &&
                  !props.isInputChanged
                }
                helperText={
                  (props.expertises[EXPERTISES.MEDICAL_EXPERTISE][
                    props.index
                  ] === undefined ||
                    !props.expertises[EXPERTISES.MEDICAL_EXPERTISE][props.index]
                      ?.evaluationAmount) &&
                  props.expertises[EXPERTISES.MEDICAL_EXPERTISE][props.index]
                    ?.evaluationAmount !== 0 &&
                  !props.isInputChanged
                    ? translate(messages.validateRequiredField, props)
                    : ''
                }
                disabled={props.isDisabled}
              />
            )}
        </>
      ) : (
        <>
          <TextField
            name={EXPERTISES_FIELDS.CALCULATED_REVENUE}
            className="calculated-amount"
            label={translate(messages.calculatedRevenue, props)}
            value={props.setExpertiseFieldValue(
              EXPERTISE_TYPE.VICTIM,
              String(props.victim.id),
              EXPERTISES_FIELDS.CALCULATED_REVENUE,
            )}
            type="number"
            onChange={props.handleVictimChange(
              props.victim.id,
              COMPTABLE_EXPERTISE_ID,
              props.victim.victimKey,
            )}
            error={
              (props.expertises[EXPERTISES.ACCOUNTING_EXPERTISE][
                props.index
              ] === undefined ||
                !props.expertises[EXPERTISES.ACCOUNTING_EXPERTISE][props.index]
                  .calculatedRevenue) &&
              !props.isInputChanged
            }
            helperText={
              (props.expertises[EXPERTISES.ACCOUNTING_EXPERTISE][
                props.index
              ] === undefined ||
                !props.expertises[EXPERTISES.ACCOUNTING_EXPERTISE][props.index]
                  .calculatedRevenue) &&
              !props.isInputChanged
                ? translate(messages.validateRequiredField, props)
                : ''
            }
            disabled={props.isDisabled}
          />
          <TextField
            name="evaluationAmount"
            label={translate(messages.revenueFieldTitle, props)}
            value={props.setExpertiseFieldValue(
              EXPERTISE_TYPE.VICTIM,
              String(props.victim.id),
              'evaluationAmount',
            )}
            className="calculated-amount"
            onChange={props.handleVictimChange(
              props.victim?.id,
              COMPTABLE_EXPERTISE_ID,
              props.victim?.victimKey,
            )}
            type="number"
            error={
              (props.expertises[EXPERTISES.ACCOUNTING_EXPERTISE][
                props.index
              ] === undefined ||
                !props.expertises[EXPERTISES.ACCOUNTING_EXPERTISE][props.index]
                  ?.evaluationAmount) &&
              !props.isInputChanged
            }
            helperText={
              (props.expertises[EXPERTISES.ACCOUNTING_EXPERTISE][
                props.index
              ] === undefined ||
                !props.expertises[EXPERTISES.ACCOUNTING_EXPERTISE][props.index]
                  ?.evaluationAmount) &&
              !props.isInputChanged
                ? translate(messages.validateRequiredField, props)
                : ''
            }
            disabled={props.isDisabled}
          />
        </>
      )}
      <TextField
        className="calculated-amount"
        label={translate(messages.calculatedCompensationFieldTitle, props)}
        value={get(props.dahirAmounts, props.victim.victimKey, 0)}
      />

      {!isAppeal && (
        <TextField
          name={EXPERTISES_FIELDS.PROVISIONNAL_EXECUTION}
          className="calculated-amount"
          label={translate(messages.provisionalExecution, props)}
          value={
            expertiseType === EXPERTISES.ACCOUNTING_EXPERTISE
              ? props.setExpertiseFieldValue(
                  EXPERTISE_TYPE.VICTIM,
                  String(props.victim.id),
                  EXPERTISES_FIELDS.PROVISIONNAL_EXECUTION,
                )
              : props.setExpertiseFieldValue(
                  String(props.victim.id),
                  EXPERTISES_FIELDS.PROVISIONNAL_EXECUTION,
                )
          }
          onChange={props.handleVictimChange(
            props.victim?.id,
            expertiseType === EXPERTISES.ACCOUNTING_EXPERTISE
              ? COMPTABLE_EXPERTISE_ID
              : MEDICAL_EXPERTISE_ID,
            props.victim.victimKey,
          )}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {translate({ ...messages.responsibiltySharePercentage }, props)}
              </InputAdornment>
            ),
          }}
          type="number"
          error={
            (props.expertises[expertiseType][props.index] === undefined ||
              !props.expertises[expertiseType][props.index]
                .provisionalExecution) &&
            props.expertises[expertiseType][props.index]
              ?.provisionalExecution !== 0 &&
            !props.isInputChanged
          }
          helperText={
            (props.expertises[expertiseType][props.index] === undefined ||
              !props.expertises[expertiseType][props.index]
                .provisionalExecution) &&
            props.expertises[expertiseType][props.index]
              ?.provisionalExecution !== 0 &&
            !props.isInputChanged
              ? translate(messages.validateRequiredField, props)
              : ''
          }
          disabled={props.isDisabled}
        />
      )}
    </main>
  );
};

export default injectIntl(VictimExpertise);
